module.exports = __webpack_public_path__ + "static/img/Cantact_KCC_Team.72a9c8f8.png";